module.exports = __webpack_public_path__ + "static/media/3-2.be051b71.mp3";